<template>
    <div>
        <rkm-row class="mb-2">
            <rkm-col cols="12">

                <rkm-button
                    v-if="data.form.historico.ambulatorio.length > 0"
                    @click="selecionarTodos()"
                    color="primary"
                >
                    <template v-if="handleDisabledAtribuidos">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>

                <rkm-button
                    v-if="!handleDisabledAtribuidos"
                    @click="print()"
                    color="primary"
                >
                    Imprimir atendimento(s) selecionado(s)
                </rkm-button>

                <rkm-button
                    v-if="data.form.historico.prontoAtendimento.length > 0"
                    @click="$refs.ModalHistoricoProntoAtendimento.open()"
                    color="primary"
                >
                    Histórico - Pronto atendimento
                </rkm-button>

                <rkm-button
                    @click="getUrlHistoricoConectaSUSV1"
                    color="primary"
                >
                    Histórico - ConectaSUS V1
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <rkm-list
            :items="data.form.historico.ambulatorio"
            @collapse-show="load"
            hide-filters
            hide-pagination
        >
            <template v-slot="{item}">

                <rkm-row>

                    <rkm-col class="flex-grow-0">

                        <rkm-row @click.stop>

                            <rkm-col>
                                <rkm-form-checkbox
                                    v-model="item.selecionado"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>

                    <rkm-col class="flex-grow-1">

                        <rkm-row>

                            <rkm-col cols="2">
                                <item
                                    :get-value="() => item.dataHora"
                                    label="Data"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <item
                                    :get-value="() => item.tipo === 'atendimento' ? 'Atendimento' : 'Pré-atendimento'"
                                    label="Tipo"
                                />
                            </rkm-col>

                            <rkm-col>
                                <item
                                    :get-value="() => `${item.lotacao.profissional.nome} - ${item.lotacao.ocupacao.codigo} - ${ item.lotacao.ocupacao.nome}`"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-button
                                    color="primary"
                                    title="Imprimir"
                                    @click="openModalImpressao($event, item)"
                                    small
                                >
                                    <rkm-icon icon="print" />
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:collapse="{item}">
                <rkm-row
                    v-if="'data' in item"
                    class="p-2"
                >
                    <rkm-col cols="12">
                        <BoxPreAtendimento
                            v-if="item.tipo === 'pre-atendimento'"
                            :item="item.data"
                        />

                        <BoxAtendimento
                            v-if="item.tipo === 'atendimento'"
                            :item="item.data"
                        />
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-list>

        <ModalHistoricoProntoAtendimento
            :data="{form: {historicoAtendimento: data.form.historico.prontoAtendimento}}"
            ref="ModalHistoricoProntoAtendimento"
        />

        <ModalImpressao
            ref="ModalImpressao"
        />
    </div>
</template>

<script>
// Components.
import BoxAtendimento from './components/atendimento/Index'
import BoxPreAtendimento from './components/pre-atendimento/Index'
import Item from './components/item/Index'
import ModalHistoricoProntoAtendimento from '@/components/pronto-atendimento/components/historico-atendimento/components/Modal'
import ModalImpressao from '@/components/ambulatorio/components/impressao/Modal'

// Mixins.
import {error, file, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        BoxAtendimento,
        BoxPreAtendimento,
        Item,
        ModalHistoricoProntoAtendimento,
        ModalImpressao
    },
    created() {
        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    props: {
        data: {type: Object, required: true},
    },
    computed: {
        handleDisabledAtribuidos() {

            const atribuidos = this.data.form.historico.ambulatorio.filter(item => item.selecionado)

            return atribuidos.length === 0 ? true : false
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load(item) {

            if (!('data' in item)) {

                this.setLoading()

                const repository = item.tipo === 'atendimento'
                    ? this.repositories.atendimento.getHistoricoAtendimentoSoap
                    : this.repositories.atendimento.getHistoricoPreAtendimento

                repository(item.id)
                    .then(({data}) => this.$set(item, 'data', data))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        getUrlHistoricoConectaSUSV1() {
            this.setLoading()

            this.repositories.atendimento.getUrlHistoricoConectaSUSV1(this.data.form.paciente.prontuario)
                .then(response => window.open(response.data.url, '_blank'))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        openModalImpressao(event, item) {

            event.stopPropagation();

            this.$refs.ModalImpressao.open(item.tipo, item.atendimentoId)
        },
        print() {

            this.data.form.historico.ambulatorio
                .filter(item => item.selecionado)
                .map(item => {

                    this.setLoading()

                    const request = item.tipo === 'atendimento'
                        ? this.repositories.pdf.atendimento(item.atendimentoId)
                        : this.repositories.pdf.preAtendimento(item.atendimentoId)

                    request
                        .then(({data, headers}) => this.openFile(data, headers['content-type']))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        selecionarTodos(){

            if(this.handleDisabledAtribuidos){

                this.data.form.historico.ambulatorio.map(item => (item.selecionado = true))
            } else {

                this.data.form.historico.ambulatorio.map(item => (item.selecionado = false))
            }
        },
    },
    mixins: [error, file, repository]
}
</script>